import { useCallback, useEffect, useState } from "react";
import _ from 'lodash'

import withMeta from "../utils/withMeta";
import Button from "../buttons/Button";
import LoadingPanel from "../LoadingPanel";
import { isDateType } from "../utils/helper";
import { dateToStr } from '../utils/convert';

import "./FormDataTable.scss"

const maxCount = 100;

const PodrFrm = (props) => {

	const { detailData, schema, primaryField, currentPage, myPage, frms, handleChangeFrm } = props
	const [isLoading, setLoading] = useState(false);
	const [myData, setMyData] = useState({});
	const [mySchema, setMySchema] = useState([]);

	const getFixedFilter = () => {

		const myJoins = frms?.Joins ?? [];
		let filters = [];

		myJoins.forEach(join => {
			let val = _.get(detailData, join.ParentField, null);
			if (val === null) val = join.Operator === "eq-ifexists" ? null : "-1";

			filters.push({
				field: join.Field,
				parentField: join.ParentField,
				value: val,
				operator: join.Operator ? join.Operator.split('-')[0] : 'in'
			})
		})
		filters.push({
			field: "Zrus",
			value: false,
			operator: "eq"
		})

		return { filters }
	}

	const getData = useCallback(async () => {
		setLoading(true);
		setMyData({});
		let res = await props.meta.getList(primaryField, getFixedFilter(), [], { skip: 0, take: maxCount });
		let dateColumns = mySchema && mySchema.length > 0 ? mySchema.filter(x => isDateType(x.filter)) : schema.filter(x => isDateType(x.filter));
		if (dateColumns.length > 0) {
			res.Data.Items.map(x => {
				dateColumns.forEach(column => {
					const value = _.get(x, column.field);
					_.set(x, column.field, dateToStr(!value || value instanceof Date ? value : value.replace(/Z$/, ""), column.format));
				})
				return x;
			})
		}
		setMyData(res);
		setLoading(false);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [detailData])

	useEffect(() => {
		//console.log("sorting")
		let sortedSchema = schema.filter(e => e.order !== null && !e.disabled).sort((a, b) => a.order - b.order);
		setMySchema(sortedSchema);
	}, [schema])

	useEffect(() => {
		if (currentPage === myPage)
			getData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [detailData, currentPage])

	// formátovanie dát v tabuľke
	const getValue = (item, el) => {

		if (el.type === 'enum') {
			return el.EnumData.find(e => e[el.primaryField] === item[el.field])?.[el.textField]
		}

		if (el.type !== 'container') {
			return item[el.field]
		}

		if (el.valueField) {
			let toReplace = el.valueField.match(/{([^}]+)}/g);
			if (!toReplace) {
				return _.get(item, [el.field, el.textField])
			}
			let finalString = el.valueField;
			toReplace.forEach((element) => {
				let propName = element.replace(/[{}]/g, "");
				const replaceWith = _.get(item, [el.field, propName]);
				finalString = finalString.replace(
					element,
					replaceWith != null ? replaceWith : ""
				);
			});
			return finalString.trim();
		} else {
			//console.log(item, el)
			return _.get(item, [el.field, el.textField])
		}
	}

	// otvorenie veľkého okna pre podradený formulár
	const showFrm = () => {
		//console.log(obj.parentProps.frms.find(x => x.Identif === obj.field.frm));
		handleChangeFrm("formDataTable", frms)
	}

	// sumár načítaných dát
	const giveSummary = (total, count) => {
		if (total === 0) {
			return "Žiadne záznamy"
		}
		return `1 - ${Math.min(total, count)} z ${total} záznamov`
	}

	//console.log(primaryField)

	return (
		<>
			<LoadingPanel isLoading={isLoading} />

			{frms !== null &&
				<div className="formDataTable_btn">
					<Button
						onClick={showFrm}
						position={"bottom"}
						//imageUrl={buildUrl('assets/icons/toolbar_podriad_formular.svg')}
						title={"Otvoriť podradený formulár v okne"}
						label={"Zobraziť"}
					/>
				</div>
			}

			<div className="formDataTable">
				<table className="formDataTable_table">
					<thead>
						<tr className="formDataTable_header">
							{(mySchema !== undefined) && mySchema.map(el => {
								return (
									<th style={{ width: el.width ?? 150 }} key={el.title} >
										<span>{el.title}</span>
									</th>
								)
							})}
						</tr>
					</thead>
					{(myData.Data !== undefined && mySchema !== undefined) &&
						<tbody className={myData.Data.TotalRecords > maxCount * .7 ? "l" : (myData.Data.TotalRecords > maxCount * .4 ? "m" : "s")}>
							{myData.Data.Items.map(item => {
								return <tr key={item[primaryField]}>
									{mySchema.map(el => {
										return <td key={item[primaryField] + el.title}>{getValue(item, el)}</td>
									})}
								</tr>
							})}
						</tbody>
					}
				</table>
				<div className="formDataTable_summary">{giveSummary(myData.Data?.TotalRecords ?? 0, maxCount)}</div>
			</div >
		</>
	)
}

export default withMeta(PodrFrm);